<a routerLink="/dashboard" matTooltip="Fejl dashboard" routerLinkActive="active" routerLinkActiveOptions="{exact:false}">
  <mat-icon
    svgIcon="alert-solid"
    class="icon-32"
    [matBadge]="antalFejl"
    [matBadgeHidden]="!antalFejl"
    matBadgeSize="small"
    aria-hidden="false"
  ></mat-icon>
  <span>Fejl dashboard</span>
</a>
